import { defaultInputProps } from '../../../FormContainer/defaultFormStates';
import { affiliateID, siteOptions } from '../../../common/commonRequests';
import ValidatePlacements from './validation';

const placementSource = [{ value: 'TY', display: 'TY' }];

export const editPlacementState = (detailsView) => ({
  site: {
    ...defaultInputProps,
    name: 'site',
    type: 'select',
    label: 'Vertical',
    options: () =>
      siteOptions(false, false, false, [], {
        value: 'none',
        display: 'Choose a Vertical',
        disabled: true
      }),
    value: 'none',
    defaultVal: 'none',
    validate: ValidatePlacements.site
  },
  affiliateID: {
    ...defaultInputProps,
    name: 'affiliateID',
    type: 'autocomplete',
    label: 'Affiliate ID',
    options: () => affiliateID(),
    value: '',
    defaultVal: 'All Affiliates',
    validate: ValidatePlacements.affiliate,
    hidden: detailsView
  },
  campaignID: {
    ...defaultInputProps,
    name: 'campaignID',
    label: 'Transparently Campaign ID',
    value: '',
    defaultVal: '',
    validate: ValidatePlacements.campaignID
  },
  source: {
    ...defaultInputProps,
    name: 'source',
    type: 'select',
    label: 'Source',
    value: 'TY',
    options: () => placementSource
  }
});
